import { Grid, Typography } from '@mui/material';
import React from 'react';
import CircleIcon from '@mui/icons-material/Circle';
import CloseIcon from '@mui/icons-material/Close';
import { isMobile } from '../../utils';

export interface AmountBlobProps {
  text: string;
  bold?: boolean;
  large?: boolean;
}

export const AmountBlob = (props: AmountBlobProps): JSX.Element => {
  let circleSize: number = 0;
  let none = false;
  if (props.text === 'Low') {
    circleSize = 0.75;
  } else if (props.text === 'Normal') {
    circleSize = 1;
  } else if (props.text === 'High') {
    circleSize = 1.25;
  } else if (props.text === 'Very High') {
    circleSize = 1.5;
  } else if (props.text === 'None') {
    none = true;
  }
  if (props.large) {
    circleSize = circleSize * 3;
  }
  return (
    <>
      <Grid
        container
        item
        xs={12}
        sx={{
          px: 2,
          alignItems: 'center',
          justifyContent: props.large
            ? 'inherit'
            : isMobile()
            ? 'right'
            : 'center',
        }}
      >
        {!circleSize ? (
          <CloseIcon
            sx={{ color: 'red', fontSize: props.large ? '3rem' : '1rem' }}
          />
        ) : (
          <CircleIcon
            sx={{
              color: 'blue',
              fontSize: circleSize + 'rem',
            }}
          />
        )}
        <Typography
          variant={props.bold ? 'bold' : 'inherit'}
          sx={{ pl: 1, sx: { fontsize: props.large ? '60px' : 'inherit' } }}
        >
          {props.text}
        </Typography>
      </Grid>
    </>
  );
};
